import axios from "axios";
import {UrlConfig} from "./urlConfig";

const urlConfig = new UrlConfig();
export default axios.create({
  baseURL: urlConfig.getBaseUrl(),
  timeout: 25000
});
